const cards = [
  {
    title: '悬疑片单：10部反转神作',
    desc: '猜到结局算我输！这些悬疑片每一部都能让你拍案叫绝。从经典到新作，烧脑指数爆表。',
    tag: '悬疑',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20film%20noir%20scene%20with%20dramatic%20shadow%20play%20on%20a%20wall%2C%20vintage%20detective%20elements%2C%20dark%20moody%20atmosphere%20with%20warm%20accent%20lighting%2C%20cinematic%20thriller%20aesthetic%2C%20rich%20contrast%2C%20no%20people%2C%20suspenseful%20composition&width=700&height=480&seq=cards-suspense-2026&orientation=landscape',
  },
  {
    title: '2024暑期档观影指南',
    desc: '这个夏天看什么？我们为你整理了一份暑期观影清单，动作、喜剧、动画全都有。',
    tag: '暑期',
    image: 'https://readdy.ai/api/search-image?query=Summer%20cinema%20vibe%20with%20vintage%20movie%20tickets%20and%20sunglasses%20on%20a%20warm%20wooden%20surface%2C%20golden%20afternoon%20sunlight%2C%20film%20reel%20decoration%2C%20nostalgic%20movie%20going%20atmosphere%2C%20soft%20warm%20tones%2C%20no%20people%2C%20editorial%20style&width=700&height=480&seq=cards-summer-guide-2026&orientation=landscape',
  },
  {
    title: '国产剧崛起：今年必看5部',
    desc: '国产剧质量越来越高了！从古装权谋到现代悬疑，这5部代表了国产剧的新高度。',
    tag: '国产剧',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20Chinese%20period%20drama%20set%20decoration%20with%20silk%20fabrics%20and%20traditional%20lanterns%2C%20warm%20golden%20lighting%2C%20classical%20aesthetic%2C%20rich%20crimson%20and%20gold%20color%20palette%2C%20cinematic%20quality%2C%20no%20people%2C%20artistic%20photography&width=700&height=480&seq=cards-chinese-drama-2026&orientation=landscape',
  },
  {
    title: '豆瓣9分+经典电影全集',
    desc: '经过时间考验的真正好片！收录豆瓣评分9.0以上的电影佳作，每一部都值得珍藏。',
    tag: '经典',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20film%20projector%20with%20golden%20light%20beam%20in%20a%20dark%20room%2C%20old%20movie%20posters%20on%20brick%20wall%2C%20nostalgic%20cinema%20atmosphere%2C%20warm%20amber%20glow%2C%20classic%20hollywood%20aesthetic%2C%20no%20people%2C%20timeless%20composition&width=700&height=480&seq=cards-classic-2026&orientation=landscape',
  },
  {
    title: '周末宅家必刷：轻松喜剧片单',
    desc: '不想动脑？这些轻松搞笑的喜剧电影最适合周末窝在沙发上看，治愈一周的疲惫。',
    tag: '喜剧',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20living%20room%20with%20large%20TV%20screen%20and%20comfortable%20couch%2C%20popcorn%20and%20drinks%20on%20coffee%20table%2C%20warm%20evening%20lighting%2C%20relaxed%20movie%20night%20atmosphere%2C%20soft%20golden%20glow%2C%20no%20people%2C%20lifestyle%20photography&width=700&height=480&seq=cards-comedy-2026&orientation=landscape',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            影视图集
          </h2>
          <p className="mt-3 text-sm text-foreground-500">精选影视专题，发现更多好内容</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {cards.map((item) => (
            <div key={item.title} className="group cursor-pointer">
              <div className="relative rounded-xl overflow-hidden bg-background-100 aspect-[3/2]">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-background-50/90 text-xs font-medium text-foreground-700">
                    {item.tag}
                  </span>
                </div>
              </div>
              <h3 className="mt-3 font-heading font-semibold text-base text-foreground-900 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}